import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function PDFViewer() {
  const location = useLocation();
  const navigate = useNavigate();

  const pdfUrl = location.state?.pdfUrl;

  if (!pdfUrl) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <h2>PDF not available</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      
      {/* TOP BAR */}
      <div
        style={{
          padding: "12px 16px",
          background: "#111",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 1000
        }}
      >
        <span>Resume Preview</span>

        <button
          onClick={() => navigate(-1)}
          style={{
            background: "#e53935",
            color: "#fff",
            border: "none",
            padding: "8px 14px",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Exit
        </button>
      </div>

      {/* PDF IFRAME */}
      <iframe
        src={pdfUrl}
        title="PDF Viewer"
        style={{
          flex: 1,
          width: "100%",
          border: "none"
        }}
      />
    </div>
  );
}

export default PDFViewer;

